import { render, staticRenderFns } from "./OrthoLawyer.vue?vue&type=template&id=4e0b3f01&scoped=true"
import script from "./OrthoLawyer.vue?vue&type=script&lang=js"
export * from "./OrthoLawyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b3f01",
  null
  
)

export default component.exports